import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationService } from './services/Auth/authentication.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Intercept } from "./interceptors/interceptors";
import { TokenStatusComponent } from './components/token-status/token-status.component';
// import { TextMaskModule } from 'angular2-text-mask'; // Move to feature modules
// TEMPORARILY DISABLED - Firebase v9 compatibility issues with AngularFire v7
// import { AngularFireModule } from '@angular/fire/compat';
// import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment, firebaseConfig } from '../environments/environment';

import { MapsProviderService } from './providers/maps-provider.service';
import { JsMapsProviderService } from './providers/js-maps-provider.service';
import { NativeMapsProviderService } from './providers/native-maps-provider.service';
import { GoogleMaps } from '@ionic-native/google-maps/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { ComponentsModule } from './components/components.module';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PubNubAngular } from "pubnub-angular2";
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';
import { ServiceWorkerModule } from "@angular/service-worker";
// import { FCM } from '@ionic-native/fcm/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';

@NgModule({
  declarations: [AppComponent, TokenStatusComponent],
  imports: [
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    // TextMaskModule, // Moved to feature modules
    CommonModule,
    // TEMPORARILY DISABLED - Firebase v9 compatibility issues with AngularFire v7
    // AngularFireModule.initializeApp(firebaseConfig),
    // AngularFireAuthModule,
    ComponentsModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.swVersionUpdate,
    }),
    IonicStorageModule.forRoot(),
  ],
  providers: [
    // FCM,
    // FirebaseX,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: Intercept, multi: true },
    AuthenticationService,
    MapsProviderService,
    JsMapsProviderService,
    NativeMapsProviderService,
    Geolocation,
    GoogleMaps,
    AndroidPermissions,
    LocationAccuracy,
    OpenNativeSettings,
    PubNubAngular,
    SocialSharing,
    // Facebook
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
